import { render, staticRenderFns } from "./SubjectShow.vue?vue&type=template&id=68eb1674"
import script from "./SubjectShow.vue?vue&type=script&lang=js"
export * from "./SubjectShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports